var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 2H10a1 1 0 0 1 1 1v.5H8.5zm-1 0v1.5H5V2zM4 2v1.5H1V3a1 1 0 0 1 1-1zM0 3v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2m11 3.5v-2H8.5v2zm-3.5 0v-2H5v2zM4 6.5v-2H1v2zM8.5 10H10a1 1 0 0 0 1-1V7.5H8.5zm-1-2.5H5V10h2.5zM4 10V7.5H1V9a1 1 0 0 0 1 1z",
    clipRule: "evenodd"
  })));
});
const SvgMatrixsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatrixsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgMkgxMEMxMC41NTIzIDIgMTEgMi40NDc3MiAxMSAzVjMuNUg4LjVWMlpNNy41IDJWMy41SDVWMkg3LjVaTTQgMlYzLjVIMVYzQzEgMi40NDc3MiAxLjQ0NzcyIDIgMiAySDRaTTAgM1YzLjVWNC41VjYuNVY3LjVWOUMwIDEwLjEwNDYgMC44OTU0MzEgMTEgMiAxMUg0SDVINy41SDguNUgxMEMxMS4xMDQ2IDExIDEyIDEwLjEwNDYgMTIgOVY3LjVWNi41VjQuNVYzLjVWM0MxMiAxLjg5NTQzIDExLjEwNDYgMSAxMCAxSDguNUg3LjVINUg0SDJDMC44OTU0MzEgMSAwIDEuODk1NDMgMCAzWk0xMSA2LjVWNC41SDguNVY2LjVIMTFaTTcuNSA2LjVWNC41SDVWNi41SDcuNVpNNCA2LjVWNC41SDFWNi41SDRaTTguNSAxMEgxMEMxMC41NTIzIDEwIDExIDkuNTUyMjggMTEgOVY3LjVIOC41VjEwWk03LjUgNy41SDVWMTBINy41VjcuNVpNNCAxMFY3LjVIMVY5QzEgOS41NTIyOCAxLjQ0NzcyIDEwIDIgMTBINFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";